import { useState, useEffect } from "react";
import { getDepartments } from "../api";
import "../App.css";

export default function ReassignModal({ currentDepartment, onClose, onSubmit }) {
  const [departments, setDepartments] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDepartments()
      .then((data) => {
        const list = Array.isArray(data) ? data : data.results || [];
        setDepartments(list.filter((d) => d.is_active && !d.is_superuser));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // Group departments by category
  const grouped = {};
  departments.forEach((dept) => {
    const catName = dept.category_name || "სხვა";
    if (!grouped[catName]) grouped[catName] = [];
    grouped[catName].push(dept);
  });

  function toggleUser(id) {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  }

  function handleSubmit() {
    if (selectedIds.length === 0) return;
    onSubmit(selectedIds);
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <h3>სხვა თანამშრომლებზე გადაგზავნა</h3>

        {loading ? (
          <p style={{ color: "#94a3b8", fontSize: 14 }}>იტვირთება...</p>
        ) : (
          <div className="reassign-list">
            {Object.entries(grouped).map(([catName, users]) => (
              <div key={catName} style={{ marginBottom: 12 }}>
                <div style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#016394",
                  marginBottom: 6,
                  borderBottom: "1px solid #e2e8f0",
                  paddingBottom: 4,
                }}>
                  {catName}
                </div>
                {users.map((dept) => {
                  const isCurrent = dept.department_name === currentDepartment;
                  return (
                    <label
                      key={dept.id}
                      className={`reassign-option ${selectedIds.includes(dept.id) ? "selected" : ""} ${isCurrent ? "current" : ""}`}
                    >
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(dept.id)}
                        onChange={() => toggleUser(dept.id)}
                        disabled={isCurrent}
                      />
                      <span className="reassign-name">
                        {dept.department_name}
                      </span>
                      <span style={{ color: "#94a3b8", fontSize: 12, marginLeft: 6 }}>
                        ({dept.email})
                      </span>
                      {isCurrent && (
                        <span className="reassign-current">მიმდინარე</span>
                      )}
                    </label>
                  );
                })}
              </div>
            ))}
          </div>
        )}

        <div className="modal-buttons">
          <button className="cancel-btn" onClick={onClose}>გაუქმება</button>
          <button
            className="send-btn"
            onClick={handleSubmit}
            disabled={selectedIds.length === 0}
          >
            გადაგზავნა {selectedIds.length > 0 && `(${selectedIds.length})`}
          </button>
        </div>
      </div>
    </div>
  );
}
